import useFetch from '../../../hooks/useFetch';
import rideApi from '../rideApi';

export default function useGetAllRides() {
    return useFetch(rideApi.getListe);
}
